var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOneOnOneInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99995 6.44444C8.54635 6.44444 9.79995 5.22566 9.79995 3.72222C9.79995 2.21878 8.54635 1 6.99995 1C5.45355 1 4.19995 2.21878 4.19995 3.72222C4.19995 5.22566 5.45355 6.44444 6.99995 6.44444Z",
    stroke: "#868FAD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4431 1.38889C13.2562 1.86524 13.8001 2.73199 13.8001 3.72222C13.8001 4.71244 13.2562 5.5792 12.4431 6.05555",
    stroke: "#868FAD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 14.5333V15H13V14.5333C13 12.7909 13 11.9197 12.6512 11.2542C12.3444 10.6688 11.8549 10.1929 11.2528 9.89458C10.5682 9.55551 9.67216 9.55551 7.88 9.55551H6.12C4.32784 9.55551 3.43176 9.55551 2.74723 9.89458C2.14511 10.1929 1.65557 10.6688 1.34878 11.2542C1 11.9197 1 12.7909 1 14.5333Z",
    stroke: "#868FAD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 15V14.5333C16.9999 12.7909 16.9999 11.9198 16.6512 11.2543C16.3444 10.6689 15.8548 10.1929 15.2527 9.89462",
    stroke: "#868FAD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneOnOneInactive);
export default __webpack_public_path__ + "static/media/oneOnOneInactive.00e71166e0ca43b489f05ff947297476.svg";
export { ForwardRef as ReactComponent };